import React from "react";
import { Input as AntInput, InputProps } from "antd";

interface Props extends InputProps {}

const Input: React.FC<Props> = (props: Props) => {
  const {
    style = { width: "100%" },
    placeholder,
    value,
    maxLength,
    ...rest
  } = props;

  return (
    <AntInput
      placeholder={placeholder || "검색어를 입력해주세요"}
      style={{ ...style }}
      maxLength={maxLength || 100}
      showCount
      value={value}
      {...rest}
    />
  );
};

Input.defaultProps = {};
export default Input;
